module.exports = __webpack_public_path__ + "img/roof.9aa2cb93.jpeg";